import { apiClient } from "../config";
import { env } from "../../config/env";

import {
  RegisterPayload,
  LoginPayload,
  ForgotPasswordPayload,
  VerifyCodePayload,
  ResetPasswordPayload,
  AuthResponse,
} from "../interface/auth.interface";

import { User } from "../interface/user.interface";

/**
 * 🔐 AUTH SERVICE
 */
class AuthService {

  /**
   * 📝 REGISTER
   */
  async register(data: RegisterPayload): Promise<AuthResponse> {
    const response = await apiClient.post<AuthResponse>(
      env.AUTH.REGISTER,
      data
    );

    return response.data;
  }

  /**
   * 🔑 LOGIN
   */
  async login(data: LoginPayload): Promise<AuthResponse> {
    try {
      const response = await apiClient.post<AuthResponse>(
        env.AUTH.LOGIN,
        data,
        { headers: { "Content-Type": "application/json" } }
      );

      return response.data;
    } catch (error: any) {
      throw error;
    }
  }

  /**
   * 🚪 LOGOUT
   */
  async logout(): Promise<AuthResponse> {
    const response = await apiClient.post<AuthResponse>(
      env.AUTH.LOGOUT
    );

    return response.data;
  }

  /**
   * 🔁 FORGOT PASSWORD
   */
  async forgotPassword(
    data: ForgotPasswordPayload
  ): Promise<AuthResponse> {
    const response = await apiClient.post<AuthResponse>(
      env.AUTH.FORGOT_PASSWORD,
      data
    );

    return response.data;
  }

  /**
   * 🔢 VERIFY CODE
   */
  async verifyCode(
    data: VerifyCodePayload
  ): Promise<AuthResponse> {
    const response = await apiClient.post<AuthResponse>(
      env.AUTH.VERIFY_CODE,
      data
    );

    return response.data;
  }

  /**
   * 🔄 RESET PASSWORD
   */
  async resetPassword(
    data: ResetPasswordPayload
  ): Promise<AuthResponse> {
    const response = await apiClient.post<AuthResponse>(
      env.AUTH.RESET_PASSWORD,
      data
    );

    return response.data;
  }

  /**
   * 👤 CURRENT USER
   */
  async getCurrentUser(): Promise<User> {
    const response = await apiClient.get<any>(
      env.USER.INFOS
    );

    return response.data.data.user;
  }
}

export const authService = new AuthService();